module.exports = __webpack_public_path__ + "img/file-circle-plus.c511964e.svg";